export const en = {
    'adjustments-rate': 'Bids shown are before adjustments',
    'button-cancel': 'Cancel',
    'button-submit': 'Apply'
};
